import { OrderNumberHeader } from "ui/OrderNumberHeader/OrderNumberHeader";

import { useSelectOrderDetails } from "../hooks/usePickingMachineSelectors";
import { usePickingStore } from "../stores/usePickingStore";

export function PickingListHeader() {
  const {
    orderNumber,
    orderWeight,
    numberOfItems,
    itemsPickedCount,
    externalDeliveryProvider,
    reseller,
  } = useSelectOrderDetails();
  const elapsedTime = usePickingStore((state) => state.elapsedTime);

  return (
    <OrderNumberHeader
      pos="sticky"
      zIndex={1}
      top={0}
      orderNumber={orderNumber}
      pickedItems={itemsPickedCount}
      totalNumberItems={numberOfItems}
      elapsedTime={elapsedTime}
      orderWeight={orderWeight}
      externalDeliveryProvider={externalDeliveryProvider}
      reseller={reseller}
    />
  );
}
